import React from 'react'
import Booking from '../Components/Bookings/Booking'

const Bookings = () => {
  return (
    <Booking />
  )
}

export default Bookings